import { Say } from "../../../languages";

type Props = {
  visible: boolean;
};

const PhotoBoothReview = (props: Props) => {
  const { visible } = props;

  if (!visible) {
    return null;
  }

  return (
    <div className="photo-moderation__booth-review">
      <p>
        <Say phrase="photo_step.qr_selected" />
      </p>
    </div>
  );
};

export default PhotoBoothReview;
